
import { defineComponent, reactive, onBeforeMount, computed } from 'vue'
import { useRoute, useRouter } from 'vue-router'

import FtlOrderState from '@/modules/FTLModule/components/FtlOrderState/index.vue'
import FtlOrderHeader from '@/modules/FTLModule/components/FtlOrderHeader/index.vue'
import FtlIntracityEditTabs from '@/modules/FTLModule/components/FtlIntracityEditTabs/index.vue'
import RadioGroup from '@/common/components/UI/RadioGroup/index.vue'

import EnterCarrierDataIntracity from '@/modules/FTLBidsModule/components/EnterCarrierDataIntracity/index.vue'
import EnterDeliveredDataIntracity from '@/modules/OrdersHistoryModule/components/EnterDeliveredDataIntracity/index.vue'
import FTLCreateAdditionalService from '@/modules/OrdersHistoryModule/components/FTLCreateAdditionalService/index.vue'

import FtlOnTheWay from '@/modules/OrdersHistoryModule/components/FtlOnTheWay/index.vue'
import EnterCompletedDataIntracity from '@/modules/OrdersHistoryModule/components/EnterCompletedDataIntracity/index.vue'
import UploadFtlOrderScan from '@/modules/OrdersHistoryModule/components/UploadFtlOrderScan/index.vue'
import UploadFtlStockScan from '@/modules/OrdersHistoryModule/components/UploadFtlStockScan/index.vue'

import TheInput from '@/common/components/UI/TheInput/index.vue'
import TheSelect from '@/common/components/UI/TheSelect/index.vue'
import TheButton from '@/common/components/UI/TheButton/index.vue'
import Cheap from '@/common/components/UI/Cheap/index.vue'

// types
import { FullFTLOrderT, StockDeliveryNoteT } from '@/core/types/orders.types'
import {
    EmitCarrierDataIntracityParams,
    EnterCarrierDataIntracityParams,
} from '@/core/types/ftl_bids.types'
import { CarrierT } from '@/core/types/carriers.types'

// constants
import { FtlFileNames } from '@/core/constants/columns/FTL.columns'

// realisations
import { orders } from '@/core/realisations/orders.realisation'
import { ftl_bids } from '@/core/realisations/ftl_bids.realisation'
import { FTL } from '@/core/realisations/FTL.realisation'
import { carriers } from '@/core/realisations/carriers.realisation'

import { DataState } from '@/core/classes/DataState.class'

// composable
import useNotifications from '@/common/composable/useNotifications'
import { useFormData } from '@/common/composable/useFormData'
import {
    AdditionalServicesFTLI,
    CompleteIntracityPayload,
} from '@/core/types/additional_services.types'

import { PRICE_MASK } from '@/core/constants/masks.constants'
import { LOADING_TYPE_OPTIONS, PAYMENT_TYPE_OPTIONS } from '@/core/constants/create_order.constants'
import { CouirerCarT, DispatcherCourierT } from '@/core/types/couriers.types'
import { couriers } from '@/core/realisations/couriers.realisation'
import { FTLLoadCapacityT, UpdateFtlIntracityOrderPayload } from '@/core/types/ftl.types'
import useHelpers from '@/common/composable/useHelpers'
import useAccount from '@/common/composable/useAccount'
import { useMaska } from '@/common/composable/useMaska'

const PRE_PAID_OPTIONS = [
    { id: 1, name: 'Да' },
    { id: 0, name: 'Нет' },
]
const SPECIAL_CONDITIONS_OPTIONS = [
    { id: 1, name: 'Да' },
    { id: 0, name: 'Нет' },
]
import { FTL_ORDER_PAYMENT_RATE_TYPES } from '@/core/constants/ftl_types.constants'

export default defineComponent({
    components: {
        FtlOrderHeader,
        FtlOrderState,
        FtlIntracityEditTabs,
        'ftl-create-additional-service': FTLCreateAdditionalService,
        FtlOnTheWay,
        EnterCompletedDataIntracity,
        UploadFtlOrderScan,
        UploadFtlStockScan,
        EnterCarrierDataIntracity,
        EnterDeliveredDataIntracity,
        TheInput,
        TheSelect,
        TheButton,
        Cheap,
        RadioGroup,
    },
    setup() {
        const route = useRoute()
        const notifications = useNotifications()
        const { getFormData } = useFormData()
        const { havePermission, havePermissions } = useAccount()
        const router = useRouter()
        const { unmaskNumbers } = useMaska()

        const order_id = Number(route.params.order_id)

        const data_state = reactive({
            cars: new DataState<CouirerCarT>({}),
            carriers: new DataState<CarrierT>({}),
            couriers: new DataState<DispatcherCourierT>({}),
            capacity_state: new DataState<FTLLoadCapacityT>({}),
        })

        const additional_state = reactive({
            is_open: false,
            stock: null as StockDeliveryNoteT | null,
        })

        const state = reactive({
            is_loading: true,
            is_failed: false,
            is_creating: false,
            is_downtime: false,
            ftlOrder: null as FullFTLOrderT | null,
            currentTab: 'general',
            //
            is_status_loading: false,
            //
            is_on_the_way_loading: false,
            is_on_the_way: false,
            //
            is_transcript_printing: false,
            is_route_printing: false,
            is_resending_to_one_c: false,
            is_invoices_printing: false,
            //
            is_scan_upload: false,
            //
            is_already_have_one_c: false,
            //
            is_printing_stock_invoice: false,
            is_carrier_loading: false,
            is_carrier: false,
            is_delivered_intracity: false,
            is_delivered_intracity_loading: false,
            is_complete_intracity: false,
            is_complete_intracity_loading: false,
        })

        const state_edit = reactive({
            take_date: null as string | null,
            take_time: null as string | null,
            act_number: null as string | null,
            act_created_at: null as string | null,
            auto_duration: null as string | null,
            auto_count: null as string | null,
            //
            declared_price: null as string | null,
            payment_type: null as number | null,
            is_pre_paid: null as number | null,
            cost_price_per_hour: null as string | null,
            cost_price: null as string | null,
            paid_price_per_hour: null as string | null,
            paid_price: null as string | null,
            //
            carrier_id: null as number | null,
            car: {
                id: null as number | null,
                brand: null as string | null,
                number: null as string | null,
            },
            car_info: {
                cubature: null as string | null,
                loading_type: null as string | null,
                temperature_regime: null as string | null,
                load_capacity: null as string | null,
            },
            dop_order_number: null as string | null,
            driver: {
                id: null as number | null,
                name: null as string | null,
                phone: null as string | null,
            },
            special_conditions: null as string | null,
            trailer_license_number: null as string | null,
            //
            additional_service: [] as AdditionalServicesFTLI[],
            stock_delivery_notes: [] as StockDeliveryNoteT[],
            //
            downtime: {
                type: 1,
                hours: null as string | number | null,
                hours_for_client: null as string | number | null,
                cost_price: null as string | number | null,
                paid_price: null as string | number | null,
            },
            sender: {
                fullAddress: null as string | null,
            }
        })

        const upload_ftl_stock_scan = reactive({
            is_opened: false,
            ftl_stock_id: null as number | null,
            ftl_stock_directionName: null as string | null,
            ftl_stock_number: null as string | null,
        })

        const uploadStockScanHandler = (stockDeliveryNote: StockDeliveryNoteT) => {
            upload_ftl_stock_scan.ftl_stock_id = stockDeliveryNote.id
            upload_ftl_stock_scan.ftl_stock_directionName = stockDeliveryNote.directionName
            upload_ftl_stock_scan.ftl_stock_number = stockDeliveryNote.number
            upload_ftl_stock_scan.is_opened = true
        }

        const uploadStockScanCancel = () => {
            upload_ftl_stock_scan.is_opened = false
            upload_ftl_stock_scan.ftl_stock_id = null
            upload_ftl_stock_scan.ftl_stock_directionName = null
            upload_ftl_stock_scan.ftl_stock_number = null
        }

        const uploadStockScanSubmit = () => {
            uploadStockScanCancel()
            loadFtlOrder()
        }

        const fillInfo = () => {
            if (!state.ftlOrder) return

            state_edit.take_date = state.ftlOrder.take_date
            state_edit.take_time = state.ftlOrder.take_time
            state_edit.act_number = state.ftlOrder.act_number

            const dateStr = state.ftlOrder.act_created_at
                ? state.ftlOrder.act_created_at.split(' ').join('T')
                : null
            const dateArr = dateStr ? dateStr.split(':') : []
            if (dateStr) {
                state_edit.act_created_at = [dateArr[0] || '00', dateArr[1] || '00'].join(':')
            }

            state_edit.auto_duration = state.ftlOrder.auto_duration
                ? state.ftlOrder.auto_duration.toString()
                : null
            state_edit.auto_count = state.ftlOrder.auto_count
                ? state.ftlOrder.auto_count.toString()
                : null

            state_edit.declared_price = state.ftlOrder.declared_price
                ? state.ftlOrder.declared_price.toString()
                : null
            state_edit.payment_type = state.ftlOrder.payment_type_id
            state_edit.is_pre_paid = state.ftlOrder.is_prepayment
            state_edit.cost_price_per_hour = state.ftlOrder.cost_price_per_hour
                ? state.ftlOrder.cost_price_per_hour.toString()
                : null
            state_edit.cost_price = state.ftlOrder.cost_price
                ? state.ftlOrder.cost_price.toString()
                : null
            state_edit.paid_price_per_hour = state.ftlOrder.paid_price_per_hour
                ? state.ftlOrder.paid_price_per_hour.toString()
                : null
            state_edit.paid_price = state.ftlOrder.paid_price
                ? state.ftlOrder.paid_price.toString()
                : null

            state_edit.carrier_id = state.ftlOrder.carrier_id
            state_edit.car.brand = state.ftlOrder.car_brand
            state_edit.car.number = state.ftlOrder.car_number
            if (state.ftlOrder.car_info) {
                state_edit.car_info.cubature = state.ftlOrder.car_info.cubature
                state_edit.car_info.loading_type = state.ftlOrder.car_info.loading_type
                state_edit.car_info.temperature_regime = state.ftlOrder.car_info.temperature_mode
                state_edit.car_info.load_capacity = state.ftlOrder.car_info.load_capacity
                    ? state.ftlOrder.car_info.load_capacity.toString()
                    : null
            }
            state_edit.dop_order_number = state.ftlOrder.dop_order_number
            state_edit.driver.id = state.ftlOrder.driver_id
            state_edit.driver.name = state.ftlOrder.driver_name
            state_edit.driver.phone = state.ftlOrder.driver_phone
            state_edit.special_conditions = state.ftlOrder.special_conditions
            state_edit.trailer_license_number = state.ftlOrder.trailer_license_number

            state_edit.additional_service = state.ftlOrder.additional_service
            state_edit.stock_delivery_notes = state.ftlOrder.stock_delivery_notes

            state_edit.sender.fullAddress = state.ftlOrder.sender.full_address
        }

        const loadFtlOrder = async () => {
            try {
                state.is_loading = true

                const response = await orders.getFTLOrder(order_id)
                state.ftlOrder = response.data

                fillInfo()

                state.is_failed = false
            } catch (error) {
                console.error(error)

                notifications.notifyError({
                    error,
                    title: 'При получении FTL заказа произошла ошибка',
                })

                state.is_failed = true
            } finally {
                state.is_loading = false
            }
        }

        const checkAvr = async () => {
            try {
                state.is_loading = true
                const response = await ftl_bids.checkAvr(order_id)
                state.is_already_have_one_c = response.data.isPosted
            } catch (error) {
                console.error(error)
            } finally {
                state.is_loading = false
            }
        }

        const loadCapacity = async () => {
            try {
                data_state.capacity_state.is_loading = true
                const response = await FTL.getCapacity()
                data_state.capacity_state.list = response.data
            } catch (error) {
                console.error(error)
            } finally {
                data_state.capacity_state.is_loading = false
            }
        }

        //

        const loadCouriers = async (page: number, search?: string) => {
            data_state.couriers.pagination.current_page = page

            try {
                data_state.couriers.is_loading = true

                const data = await couriers.getList({
                    page,
                    name: search,
                    companyId: state_edit.carrier_id,
                    statusIds: [2],
                    limit: 9999,
                })

                data_state.couriers.list = data.data
                data_state.couriers.pagination.total_pages = data.meta.last_page

                data_state.couriers.is_failed = false
                data_state.couriers.failure.error_state.is_cancel = false
            } catch (error) {
                data_state.couriers.failure.catchError(error)

                if (!data_state.couriers.failure.error_state.is_cancel) {
                    data_state.couriers.is_failed = true
                }
            } finally {
                if (!data_state.couriers.failure.error_state.is_cancel) {
                    data_state.couriers.is_loading = false
                }
            }
        }

        const loadMoreCouriers = async (page: number) => {
            if (page > data_state.couriers.pagination.total_pages) return
            data_state.couriers.pagination.current_page = page

            try {
                data_state.couriers.is_loading = true

                const response = await couriers.getList({ page, statusIds: [2], limit: 9999 })
                data_state.couriers.list = data_state.couriers.list.concat(response.data)

                data_state.couriers.pagination.total_pages = response.meta.last_page

                data_state.couriers.is_failed = false
                data_state.couriers.failure.error_state.is_cancel = false
            } catch (error) {
                data_state.couriers.failure.catchError(error)

                if (!data_state.couriers.failure.error_state.is_cancel) {
                    data_state.couriers.is_failed = true
                }
            } finally {
                if (!data_state.couriers.failure.error_state.is_cancel) {
                    data_state.couriers.is_loading = false
                }
            }
        }

        const searchCouriers = (search_query: string) => {
            loadCarriers(1, search_query)
        }

        const unshiftFindedCourier = async (carrier: DispatcherCourierT) => {
            await loadCarriers(data_state.couriers.pagination.current_page)
            data_state.couriers.list.unshift(carrier)
        }

        const onCourierSelect = (driver_id: number) => {
            if (!driver_id) return

            const courier = data_state.couriers.list.find((courier) => courier.id === driver_id)

            if (courier) {
                state_edit.driver.id = courier.id
                state_edit.driver.phone = courier.phoneNumber
                state_edit.driver.name = courier.fullName
            }
        }

        //

        const loadCarriers = async (page: number, search?: string) => {
            data_state.carriers.pagination.current_page = page

            try {
                const params = {
                    page,
                    search,
                    getAllCarriers: 1,
                    limit: 9999,
                    statusId: 2,
                }

                data_state.carriers.is_loading = true
                const response = await carriers.getList(params)
                data_state.carriers.list = response.data

                data_state.carriers.pagination.total_pages = response.meta.last_page

                data_state.carriers.is_failed = false
                data_state.carriers.failure.error_state.is_cancel = false
            } catch (error) {
                data_state.carriers.failure.catchError(error)

                if (!data_state.carriers.failure.error_state.is_cancel) {
                    data_state.carriers.is_failed = true
                }
            } finally {
                if (!data_state.carriers.failure.error_state.is_cancel) {
                    data_state.carriers.is_loading = false
                }
            }
        }

        const loadMoreCarriers = async (page: number) => {
            if (page > data_state.carriers.pagination.total_pages) return
            data_state.carriers.pagination.current_page = page

            try {
                const params = {
                    page,
                    getAllCarriers: 1,
                    limit: 9999,
                    statusId: 2,
                }

                data_state.carriers.is_loading = true

                const response = await carriers.getList(params)
                data_state.carriers.list = data_state.carriers.list.concat(response.data)

                data_state.carriers.pagination.total_pages = response.meta.last_page

                data_state.carriers.is_failed = false
                data_state.carriers.failure.error_state.is_cancel = false
            } catch (error) {
                data_state.carriers.failure.catchError(error)

                if (!data_state.carriers.failure.error_state.is_cancel) {
                    data_state.carriers.is_failed = true
                }
            } finally {
                if (!data_state.carriers.failure.error_state.is_cancel) {
                    data_state.carriers.is_loading = false
                }
            }
        }

        const searchCarriers = (search_query: string) => {
            loadCarriers(1, search_query)
        }

        const unshiftFindedCarrier = async (carrier: CarrierT) => {
            await loadCarriers(data_state.carriers.pagination.current_page)
            data_state.carriers.list.unshift(carrier)
        }

        //

        const loadCars = async (page: number, search: string | null = null) => {
            data_state.cars.pagination.current_page = page

            try {
                data_state.cars.is_loading = true

                const response = await couriers.getCars({
                    page,
                    number: search,
                })

                data_state.cars.list = response.data
                data_state.cars.pagination.total_pages = response.meta.last_page

                data_state.cars.is_failed = false
            } catch (error) {
                data_state.cars.is_failed = true
            } finally {
                data_state.cars.is_loading = false
            }
        }

        const loadMoreCars = async (page: number) => {
            if (page > data_state.cars.pagination.total_pages) return
            data_state.cars.pagination.current_page = page

            try {
                data_state.cars.is_loading = true

                const response = await couriers.getCars({
                    page,
                })
                data_state.cars.list = data_state.cars.list.concat(response.data)
                data_state.cars.pagination.total_pages = response.meta.last_page

                data_state.cars.is_failed = false
                data_state.cars.is_failed = false
            } catch (error) {
                data_state.cars.is_failed = true
            } finally {
                data_state.cars.is_loading = false
            }
        }

        const searchCars = (search_query: string) => {
            loadCars(1, search_query)
        }

        const unshiftFindedCar = async (car: CouirerCarT) => {
            await loadCars(data_state.cars.pagination.current_page)
            data_state.cars.list.unshift(car)
        }

        const onCarSelect = (id: number) => {
            const car_selected = data_state.cars.list.find((car) => car.id === id)

            if (car_selected) {
                state_edit.car.brand = car_selected.model
                state_edit.car.number = car_selected.number
            }
        }

        //

        const assignStatus = async (status_code: string) => {
            if (status_code === 'canceled') {
                const answer = confirm('Вы действительно хотите отменить FTL заказ?')
                if (!answer) return
            }

            try {
                state.is_status_loading = true

                const params = {
                    id: order_id,
                    status_code,
                }

                await ftl_bids.changeStatusFTLOrder(order_id, getFormData(params))

                notifications.notify({
                    title: 'Статус изменен',
                    type: 'success',
                })

                await loadFtlOrder()
            } catch (error) {
                notifications.notifyError({
                    error,
                    title: 'При изменении статуса произошла ошибка!',
                })
            } finally {
                state.is_status_loading = false
            }
        }

        const assignStatusOnTheWayHandler = () => {
            if (state.ftlOrder) {
                if (state.ftlOrder.ftl_type === 1) {
                    state.is_on_the_way = true
                } else {
                    assignStatus('on_the_way')
                }
            }
        }

        const onTheWaySubmit = async (payload: FormData) => {
            try {
                state.is_on_the_way_loading = true

                await ftl_bids.changeStatusFTLOrder(order_id, payload)

                notifications.notify({
                    title: 'Статус изменен',
                    type: 'success',
                })

                state.is_on_the_way = false

                await loadFtlOrder()
            } catch (error) {
                notifications.notifyError({
                    error,
                    title: 'При изменении статуса произошла ошибка!',
                })
            } finally {
                state.is_on_the_way_loading = false
            }
        }

        const onTheWayCancel = () => {
            if (state.is_on_the_way_loading) return
            state.is_on_the_way = false
        }

        const toggleDelivered = () => (state.is_delivered_intracity = !state.is_delivered_intracity)
        const toggleCompleteIntracity = () =>
            (state.is_complete_intracity = !state.is_complete_intracity)

        const onDeliveredIntracitySubmit = async (delivery_data: any) => {
            try {
                state.is_delivered_intracity_loading = true

                const params: any = {
                    delivery_date: delivery_data.delivery_date,
                    delivery_time: delivery_data.delivery_time,
                    received_by: delivery_data.received_by,
                    auto_count: delivery_data.auto_count,
                    auto_duration: delivery_data.auto_duration,
                }

                if (delivery_data.has_downtime) {
                    params.has_downtime = delivery_data.has_downtime
                    params.downtime = delivery_data.downtime
                }

                await ftl_bids.enterDeliveryDataIntracity(order_id, params)

                notifications.notify({
                    title: 'Данные о доставке успешно внесены',
                    type: 'success',
                })

                toggleDelivered()
                loadFtlOrder()
            } catch (error) {
                console.error(error)
                notifications.notifyError({
                    error,
                    title: 'При внесении данных о доставке произошла ошбика',
                })
            } finally {
                state.is_delivered_intracity_loading = false
            }
        }

        const onDelieveredIntracityCancel = () => {
            if (state.is_delivered_intracity_loading) return
            state.is_delivered_intracity = false
        }

        const onCompleteIntracitySubmit = async (payload?: CompleteIntracityPayload) => {
            try {
                state.is_complete_intracity_loading = true

                await ftl_bids.completeIntracity(order_id, payload)

                notifications.notify({
                    title: 'Заказ завершен',
                    type: 'success',
                })

                toggleCompleteIntracity()
                loadFtlOrder()
            } catch (error) {
                console.error(error)
                notifications.notifyError({
                    error,
                    title: 'При завершении заказа произошла ошбика',
                })
            } finally {
                state.is_complete_intracity_loading = false
            }
        }

        const onCompleteIntracityCancel = () => {
            if (state.is_complete_intracity_loading) return
            state.is_complete_intracity = false
        }

        const onPrintTranscript = async () => {
            try {
                state.is_transcript_printing = true

                const response = await ftl_bids.exportExcel(order_id)

                const download_url = window.URL.createObjectURL(response)

                const link = document.createElement('a')
                link.href = download_url
                link.target = '_blank'
                link.setAttribute('download', 'Транскрипт')
                document.body.appendChild(link)
                link.click()
                link.remove()
            } catch (e) {
                console.log(e)
            } finally {
                state.is_transcript_printing = false
            }
        }

        const saveFile = (content: Blob, file_name: string) => {
            const download_url = window.URL.createObjectURL(content)

            const link = document.createElement('a')
            link.href = download_url
            link.setAttribute('download', file_name)
            document.body.appendChild(link)
            link.click()
            link.remove()
        }

        const onPrintRoute = async () => {
            try {
                state.is_route_printing = true

                const response = await FTL.printRoute(order_id)
                saveFile(response, `FTL рейс №${order_id}.pdf`)
            } catch (error) {
                console.error(error)
                notifications.notifyError({ error, title: 'При распечатке рейса произошла ошибка' })
            } finally {
                state.is_route_printing = false
            }
        }

        const assignStatusCanceled = () => {
            assignStatus('canceled')
        }

        const onPrintInvoices = async () => {
            if (state.is_invoices_printing) return

            try {
                state.is_invoices_printing = true

                const response = await FTL.printFtlOrderInvoices(order_id)
                saveFile(response, `Накладные FTL заказа ${order_id}`)
            } catch (error) {
                console.error(error)

                notifications.notifyError({
                    error,
                    title: 'При распечатке накладных произошла ошибка',
                })
            } finally {
                state.is_invoices_printing = false
            }
        }

        const onDownloadScan = () => {
            const link = document.createElement('a')
            link.href = (state.ftlOrder as FullFTLOrderT).scan as string
            link.target = '_blank'
            link.setAttribute('download', `Скан FTL заказ №${order_id}`)
            document.body.appendChild(link)
            link.click()
            link.remove()
        }

        const onScanUploadHandler = () => {
            state.is_scan_upload = true
        }

        const onScanUploadSubmit = () => {
            state.is_scan_upload = false
            loadFtlOrder()
        }

        const onScanUploadCancel = () => {
            state.is_scan_upload = false
        }

        const printStockInvoiceHandler = async (index: number) => {
            if (state.is_printing_stock_invoice) return

            try {
                state.is_printing_stock_invoice = true

                const response = await FTL.printFtlOrderStockDeliveryNoteInvoice(order_id, index)
                saveFile(response, `Накладная FTL заказа ${order_id} пункта ${index + 1}`)
            } catch (error) {
                console.error(error)
                notifications.notifyError({
                    error,
                    title: 'При распечатке накладной произошла ошибка',
                })
            } finally {
                state.is_printing_stock_invoice = false
            }
        }

        const toggleCarrier = () => (state.is_carrier = !state.is_carrier)

        const getCarrierParams = (
            ftl_type: number,
            shipment_type: number,
            carrier: EmitCarrierDataIntracityParams
        ): EnterCarrierDataIntracityParams | null => {
            if (!state.ftlOrder) return null

            if (ftl_type === 1 && shipment_type === 2) {
                return {
                    id: state.ftlOrder.id,
                    carrier_id: carrier.carrier_id,
                }
            } else {
                const params: EnterCarrierDataIntracityParams = {
                    id: state.ftlOrder.id,
                    ...carrier,
                }

                if (carrier.payment_rate_type_id === 1) {
                    params.cost_price_per_hour = carrier.cost_price
                    delete params.cost_price
                }

                return params
            }
        }

        const enterCarrierDataSubmit = async (carrier: EmitCarrierDataIntracityParams) => {
            if (!state.ftlOrder) return
            if (state.is_carrier_loading) return

            try {
                state.is_carrier_loading = true

                const params = getCarrierParams(
                    state.ftlOrder.ftl_type,
                    state.ftlOrder.shipment_type_id,
                    carrier
                )

                if (!params) return

                await ftl_bids.enterCarrierDataIntracity(params as EnterCarrierDataIntracityParams)

                notifications.notify({
                    title: 'Данные о перевозчике заполнены',
                    type: 'success',
                })

                toggleCarrier()
                loadFtlOrder()
            } catch (error) {
                notifications.notifyError({
                    error,
                    title: 'При внесении данных о перевозчике произошла ошибка!',
                })
            } finally {
                state.is_carrier_loading = false
            }
        }

        const onCapacityChange = (capacity: string) => {
            const { findObjectByValue } = useHelpers()
            const capacity_obj = findObjectByValue(
                'load_capacity',
                capacity,
                data_state.capacity_state.list
            )

            if (!capacity_obj) return
            state_edit.car_info.cubature = capacity_obj.cubature
        }

        const delete_additional_service_state = reactive({
            is_loading: false,
        })

        const deleteAdditionalService = async (index: number, additional_service_id: number) => {
            if (delete_additional_service_state.is_loading) return

            const answer = confirm('Вы действительно хотите удалить доп.услугу?')
            if (!answer) return

            try {
                delete_additional_service_state.is_loading = true

                await FTL.deleteOrderAdditionalService(additional_service_id)

                notifications.notify({ title: 'Доп. услуга удалена', type: 'success' })
                loadFtlOrder()
            } catch (error) {
                console.error(error)
                notifications.notifyError({
                    error,
                    title: 'При удалении доп. услуги произошла ошибка',
                })
            } finally {
                delete_additional_service_state.is_loading = false
            }
        }

        const onCarrierChange = (newWalue: number, additionalService: AdditionalServicesFTLI) => {
            const carrier = data_state.carriers.list.find((c) => c.id === newWalue)
            if (carrier) {
                additionalService.carrier_name = carrier.name
            }
        }

        const getCostTotal = (additionalService: AdditionalServicesFTLI) => {
            if (isCompleted.value) return additionalService.cost_total

            const value = Number(additionalService.value)
            const duration = Number(additionalService.duration)
            const cost_per_hour = Number(additionalService.cost_per_hour)

            return value * duration * cost_per_hour
        }

        const isCompleted = computed(() =>
            Boolean(
                state.ftlOrder &&
                    state.ftlOrder.status_code === 'completed' &&
                    state.is_already_have_one_c
            )
        )

        const getPaidPriceTotal = (additionalService: AdditionalServicesFTLI) => {
            if (isCompleted.value) return additionalService.paid_price_total

            const value = Number(additionalService.value)
            const duration_client = Number(additionalService.duration_client)
            const paid_price_per_hour = Number(additionalService.paid_price_per_hour)

            return value * duration_client * paid_price_per_hour
        }

        const toggleAdditionalService = (stock?: StockDeliveryNoteT) => {
            additional_state.is_open = !additional_state.is_open
            if (stock) {
                additional_state.stock = stock
            } else {
                additional_state.stock = null
            }
        }

        const onSubmitServices = () => {
            toggleAdditionalService()
            loadFtlOrder()
        }

        const saveOrder = async () => {
            if (!state_edit.take_date) {
                notifications.notify({
                    title: 'Пожалуйста, заполните дату забора в разделе "Основная информация"',
                    type: 'danger',
                })
                return
            }
            if (!state_edit.take_time) {
                notifications.notify({
                    title: 'Пожалуйста, заполните время забора в разделе "Основная информация"',
                    type: 'danger',
                })
                return
            }

            try {
                state.is_creating = true

                let additional_services = [...state_edit.additional_service]
                state_edit.stock_delivery_notes.forEach((s) => {
                    s.additional_service.forEach((item) => additional_services.push(item))
                })

                additional_services = additional_services.map((service) => {
                    const seviceEdited = {
                        ...service,
                    }

                    if (state.ftlOrder && state.ftlOrder.status_code !== 'completed') {
                        seviceEdited.paid_price_total = getPaidPriceTotal(service)
                        seviceEdited.cost_total = getCostTotal(service)
                    }

                    return seviceEdited
                })

                const dateStr = state_edit.act_created_at ? state_edit.act_created_at + ':00' : ''

                const payload: UpdateFtlIntracityOrderPayload = {
                    take_date: state_edit.take_date as string,
                    take_time: state_edit.take_time as string,
                    act_number: state_edit.act_number as string,
                    act_created_at: state_edit.act_created_at ? dateStr : '',
                    auto_duration: state_edit.auto_duration as string,
                    auto_count: state_edit.auto_count as string,
                    //
                    declared_price: state_edit.declared_price
                        ? Number(unmaskNumbers(state_edit.declared_price))
                        : null,
                    payment_type: state_edit.payment_type as number,
                    is_pre_paid: state_edit.is_pre_paid as number,
                    cost_price_per_hour: state_edit.cost_price_per_hour
                        ? Number(state_edit.cost_price_per_hour)
                        : null,
                    cost_price: state_edit.cost_price ? Number(state_edit.cost_price) : null,
                    paid_price_per_hour: state_edit.paid_price_per_hour
                        ? Number(state_edit.paid_price_per_hour)
                        : null,
                    paid_price: state_edit.paid_price ? Number(state_edit.paid_price) : null,
                    //
                    carrier_id: state_edit.carrier_id as number,
                    car: {
                        id: state_edit.car.id as number,
                        brand: state_edit.car.brand as string,
                        number: state_edit.car.number as string,
                    },
                    car_info: {
                        cubature: state_edit.car_info.cubature as string,
                        loading_type: state_edit.car_info.loading_type as string,
                        temperature_regime: state_edit.car_info.temperature_regime as string,
                        load_capacity: state_edit.car_info.load_capacity as string,
                    },
                    dop_order_number: state_edit.dop_order_number as string,
                    driver: {
                        id: state_edit.driver.id as number,
                        name: state_edit.driver.name as string,
                        phone: state_edit.driver.phone as string,
                    },
                    special_conditions: state_edit.special_conditions
                        ? state_edit.special_conditions.toString()
                        : null,
                    trailer_license_number: state_edit.trailer_license_number as string,
                    //
                    additional_services,
                    //
                    downtime: {
                        type: state_edit.downtime.type,
                        hours: Number(state_edit.downtime.hours),
                        hours_for_client: Number(state_edit.downtime.hours_for_client),
                        cost_price: Number(state_edit.downtime.cost_price),
                        paid_price: Number(state_edit.downtime.paid_price),
                    },
                    sender: {
                        fullAddress: state_edit.sender.fullAddress
                    }
                }

                if (state.ftlOrder && !state.ftlOrder.is_need_car) {
                    payload.car = null
                    payload.car_info = null
                    payload.driver = null
                }

                await FTL.updateOrderLikeIntracity(order_id, payload)

                notifications.notify({
                    title: 'Заказ отредактирован',
                    type: 'success',
                })

                if (state.ftlOrder) {
                    if (state.ftlOrder.ftl_type === 2) {
                        router.replace(`/ftl/intracity/${order_id}`)
                    } else {
                        router.replace(`/ftl-orders/${order_id}`)
                    }
                }
            } catch (error) {
                notifications.notifyError({
                    error,
                    title: 'Ошибка сохранения FTL ВНГ заказа',
                })
            } finally {
                state.is_creating = false
            }
        }

        const isCanAddService = computed(() =>
            havePermission('cabinet-ftl-order-additional-service-create')
        )

        const ftlOrderFilesArray = computed(() => {
            if (!state.ftlOrder) return []

            return Object.entries(state.ftlOrder.files).map(([key, file]) => {
                return {
                    id: `file-${key}`,
                    path: file.url,
                    original_name: file.fileName,
                    title: FtlFileNames[key as keyof typeof FtlFileNames] || 'Файл без типа',
                }
            })
        })

        const senderCity = computed(() => {
            if (state.ftlOrder) {
                if (state.ftlOrder.sender) {
                    return state.ftlOrder.sender.city
                }
            }

            return null
        })

        const getVatText = computed(() => {
            if (state.ftlOrder && state.ftlOrder.cost_price_with_nds) {
                return 'с НДС'
            }

            return 'без НДС'
        })

        const getNdsText = (isNds: boolean) => {
            return isNds ? 'НДС включен' : 'НДС не включен'
        }

        const getNdsClass = (isNds: boolean) => {
            let cheapClass = 'small ml-3 '

            if (isNds) cheapClass += 'green'

            return cheapClass
        }

        const toggleDowntime = () => {
            state.is_downtime = !state.is_downtime
        }

        const getPlaceholder = (placeholder: string) => {
            if (state_edit.downtime) {
                return state_edit.downtime.type === 2 ? `${placeholder} (за час)` : placeholder
            }

            return placeholder
        }

        onBeforeMount(() => {
            loadCars(1)
            loadCarriers(1)
            loadCouriers(1)
            loadCapacity()
            loadFtlOrder()
            checkAvr()
        })

        return {
            state,
            state_edit,
            data_state,
            delete_additional_service_state,
            additional_state,
            upload_ftl_stock_scan,
            onSubmitServices,
            toggleAdditionalService,
            getPlaceholder,
            getCostTotal,
            getPaidPriceTotal,
            deleteAdditionalService,
            loadFtlOrder,
            assignStatusOnTheWayHandler,
            onTheWaySubmit,
            onTheWayCancel,
            onDeliveredIntracitySubmit,
            onDelieveredIntracityCancel,
            onCompleteIntracitySubmit,
            onCompleteIntracityCancel,
            onPrintTranscript,
            onPrintRoute,
            assignStatusCanceled,
            onPrintInvoices,
            onDownloadScan,
            onScanUploadHandler,
            onScanUploadSubmit,
            onScanUploadCancel,
            uploadStockScanHandler,
            uploadStockScanCancel,
            uploadStockScanSubmit,
            printStockInvoiceHandler,
            ftlOrderFilesArray,
            senderCity,
            toggleCarrier,
            toggleDelivered,
            enterCarrierDataSubmit,
            toggleCompleteIntracity,
            loadCarriers,
            loadMoreCarriers,
            searchCarriers,
            unshiftFindedCarrier,
            loadCouriers,
            loadMoreCouriers,
            searchCouriers,
            unshiftFindedCourier,
            onCourierSelect,
            loadCapacity,
            onCapacityChange,
            havePermissions,
            onCarrierChange,
            saveOrder,
            loadCars,
            loadMoreCars,
            searchCars,
            unshiftFindedCar,
            onCarSelect,
            getNdsText,
            getNdsClass,
            toggleDowntime,
            isCompleted,
            getVatText,
            isCanAddService,
            PRICE_MASK,
            PRE_PAID_OPTIONS,
            PAYMENT_TYPE_OPTIONS,
            LOADING_TYPE_OPTIONS,
            SPECIAL_CONDITIONS_OPTIONS,
            FTL_ORDER_PAYMENT_RATE_TYPES,
        }
    },
})
